import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { connectRouter } from 'connected-react-router'
import UserAuthentication from '../ducks/UserAuthentication';
import Users from '../ducks/Users';
import Things from '../ducks/Things';
import Groups from '../ducks/Groups';
import Reports from '../ducks/Reports';
import Visualization from '../ducks/Visualization';
import { middleware } from '../middlewares/index';

export default function configureStore(history, initialState) {
  const reducers = {
    userAuthentication: UserAuthentication.reducer,
    users: Users.reducer,
    things: Things.reducer,
    groups: Groups.reducer,
    Reports: Reports.reducer,
    visualization : Visualization.reducer 
  };
  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
    enhancers.push(window.devToolsExtension());
  }

  const rootReducer = combineReducers({
    ...reducers,
    router: connectRouter(history)
  });

  return createStore(rootReducer, initialState, compose(applyMiddleware(...middleware), ...enhancers));
}
